import React from "react";
import { HandCoins, HeartHandshake, ShoppingBasket, Users } from "lucide-react";
import { SectorSection } from "./ExchangeGovSection";

const CARDS = [
  {
    id: "volunteers", Icon: Users, title: "Congregation Volunteer Network",
    metrics: [
      { label: "Volunteer hours logged", to: 12480 },
      { label: "Mentors matched", to: 286 },
      { label: "Active ministries", to: 34 },
    ],
    bars: [38, 46, 55, 63, 74, 88],
  },
  {
    id: "donor-ledger", Icon: HandCoins, title: "Donor & Tithe Impact Ledger",
    metrics: [
      { label: "Dollars given", to: 1.8, decimals: 1, prefix: "$", suffix: "M" },
      { label: "Cost per life changed", to: 6240, prefix: "$" },
      { label: "Donor retention", to: 89, suffix: "%" },
    ],
    bars: [44, 51, 58, 66, 79, 91],
  },
  {
    id: "pantry", Icon: ShoppingBasket, title: "Shared Resource Pantry & Clothing Closet",
    metrics: [
      { label: "Items distributed", to: 48210 },
      { label: "Families served", to: 1342 },
      { label: "Restock alerts today", to: 7 },
    ],
    bars: [70, 62, 81, 74, 88, 79],
  },
  {
    id: "spiritual-care", Icon: HeartHandshake, title: "Spiritual Care & Mentorship Tracker",
    metrics: [
      { label: "Counseling sessions", to: 3916 },
      { label: "Mentor check-ins", to: 8752 },
      { label: "Milestones celebrated", to: 614 },
    ],
    bars: [35, 48, 57, 69, 80, 93],
  },
];

export const CHURCH_CUES = [
  { phrase: "volunteer network", target: "exchange-church-card-volunteers" },
  { phrase: "tithe", target: "exchange-church-card-donor-ledger" },
  { phrase: "pantry", target: "exchange-church-card-pantry" },
  { phrase: "spiritual care", target: "exchange-church-card-spiritual-care" },
];

// Beat 03 — Churches & Nonprofits.
export default function ExchangeChurchSection() {
  return (
    <SectorSection sector="church" beatId="church" eyebrow="// 03 · Sector" title="Churches & Nonprofits" cards={CARDS}
      dockLabel="What ministries get"
      dockItems={["Every volunteer hour logged, every mentor matched", "Proof of what each gift accomplishes", "A shared pantry with restock alerts", "Spiritual care tracked milestone by milestone"]} />
  );
}
